(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/app-notifications/app-notifications.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/app-notifications/app-notifications.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const Checkbox = svs.ui.reactForm.Checkbox;
const _svs$myProfile$react$ = svs.myProfile.react.pages.notifications.appNotifications.appNotificationsService,
  getPlayerPreferencesAsync = _svs$myProfile$react$.getPlayerPreferencesAsync,
  putCustomersProductTogglesAsync = _svs$myProfile$react$.putCustomersProductTogglesAsync;
const showSettingsTechnicalError = svs.myProfile.react.shared.dialogs.showSettingsTechnicalError;
const trackAppNotification = svs.myProfile.react.shared.tracking.trackAppNotification;
const AppNotifications = () => {
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoadingState = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    notificationToggle = _useState4[0],
    setNotificationToggle = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    mainChecked = _useState6[0],
    setMainChecked = _useState6[1];

  const checkForTruthy = toggles => Object.values(toggles).some(element => element === true);

  const getPreferenceData = React.useCallback(async () => {
    const _await$getPlayerPrefe = await getPlayerPreferencesAsync(),
      error = _await$getPlayerPrefe.error,
      preferences = _await$getPlayerPrefe.preferences;
    if (error) {
      showSettingsTechnicalError('På grund av ett tekniskt fel kan vi just nu inte visa dina inställningar. Vänligen försök igen senare.');
    }
    const toggles = (preferences === null || preferences === void 0 ? void 0 : preferences.notificationToggles) && JSON.parse(preferences.notificationToggles) || {};
    const toggleState = checkForTruthy(toggles);
    setNotificationToggle(toggleState);
    setLoadingState(false);
  }, []);
  useEffect(() => {
    getPreferenceData();
  }, [getPreferenceData]);
  useEffect(() => {
    setMainChecked(Boolean(notificationToggle));
  }, [notificationToggle]);

  const updateState = newTruthyState => {
    setNotificationToggle(newTruthyState);
  };

  const handleClickToggleAll = async () => {
    const newValue = !mainChecked;
    const togglesTemplate = {
      productName: 'all',
      toggleOn: newValue
    };
    const response = await putCustomersProductTogglesAsync(togglesTemplate);
    if (response !== null && response !== void 0 && response.error) {
      showSettingsTechnicalError('Ett fel inträffade när dina notifieringsinställningar skulle sparas, försök igen senare.');
      return null;
    }
    trackAppNotification(!mainChecked);
    updateState(newValue);
  };
  return React.createElement("div", null, !loading && React.createElement("div", {
    className: "margin-top"
  }, React.createElement(Checkbox, {
    checked: mainChecked,
    onChange: handleClickToggleAll
  }, "Notiser i v\xE5r app n\xE4r dina nummerspel \xE4r avgjorda och kan r\xE4ttas")));
};
svs.myProfile.react.pages.notifications.appNotifications.AppNotifications = AppNotifications;

 })(window);